// account-cabinet-self-progress-subscriptions-tabs.simple.js
const DATA_ATTR = 'data-account-cabinet-self-progress-subscriptions';
const CLASS_PREFIX = 'account-cabinet-self-progress-subscriptions';


function initPersonalAccountTabProgressMy($container) {

    init();

    function init() {

    }

}
